import CONSTANTS from "../../assets/js/Constants"

//reducer gồm các hàm update trạng thái dựa vào kết quả từ api
const maintainance_report = {}
export default function (state = maintainance_report, { type, payload }) {
    switch (type) {
        case CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_VEHICLE_LIST:
            return { ...state, vehiclesList: payload }
        case CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_MAINTAINANCE_WORKS:
            return { ...state, maintainanceWorks: payload }
        case CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_VENDOR_SUPPLIES:
            return { ...state, vendorSupplies: payload }
        case CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_REPORT_DATA_ACTION:
            return { ...state, reportData: payload }
        case CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_DOWNLOAD_REPORT_ACTION:
            return { ...state, downloadReport: payload }
        default:
            return { ...state }
    }
}
